'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_037eb246 = {"container":"CountDown_module_container__025fd1f1"};
require("../../../assets/cjs/components/CountDown/src/CountDown~_DbWJRYE.css");

exports.default = modules_037eb246;
//# sourceMappingURL=CountDown.module.less.js.map
